import config from "@/config"
import http from "@/utils/request"

export default {
    dfInvoice: {
        getPageList: {
            url: `${config.API_URL}/api/app/df-invoice/page-list`,
            name: "获取df发票分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getAsinPageList: {
            url: `${config.API_URL}/api/app/df-invoice/asin-page-list`,
            name: "根据ASIN来获取发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        exportInvoice: {
            url: `${config.API_URL}/api/app/df-invoice/export-invoice`,
            name: "根据发票ID导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        },
        exportAsin: {
            url: `${config.API_URL}/api/app/df-invoice/export-asin`,
            name: "根据ASIN导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        },
        exportSku: {
            url: `${config.API_URL}/api/app/df-invoice/export-sku`,
            name: "根据SKU导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        },
        getSkuPageList: {
            url: `${config.API_URL}/api/app/df-invoice/sku-page-list`,
            name: "根据SKU来获取发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
    },
    poInvoice: {
        getPageList: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/page-list`,
            name: "获取PO发票分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getCanCreatePageList: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/can-create-list`,
            name: "获取可以创建的PO分页发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        getPoOrderDetail: {
            url: `${config.API_URL}/api/app/po-invoice/details`,
            name: "获取可以创建的PO分页发票数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        create: {
            url: `${config.API_URL}/api/app/po-invoice`,
            name: "创建PO发票",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/export-asin`,
            name: "根据ASIN导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    poInvoiceQuickPayDiscount: {
        getQuickPayDiscountPageList: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/quick-pay-discount-page-list`,
            name: "获取PO收款费用分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/amazon-po-invoice/get-quick-pay-discount-export`,
            name: "导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    coOpSalesDiscount: {
        getPageList: {
            url: `${config.API_URL}/api/app/co-op-sales-discount/page-list`,
            name: "获取销售折扣费用分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/co-op-sales-discount/export`,
            name: "导出发票数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    coOpAccrual: {
        coOpAccrualCurrent: {
            getPageList: {
                url: `${config.API_URL}/api/app/co-op-accrual-current/page-list`,
                name: "获取销售折扣费用分页数据",
                get: async function (params) {
                    return await http.get(this.url, params);
                }
            },
            export: {
                url: `${config.API_URL}/api/app/co-op-accrual-current/export`,
                name: "导出发票数据",
                post: async function (params) {
                    return await http.post(this.url, params, {
                        responseType: 'blob'
                    });
                }
            }
        },
        coOpAccrualPrevious: {
            getPageList: {
                url: `${config.API_URL}/api/app/co-op-accrual-previous/page-list`,
                name: "获取往期应计修订",
                get: async function (params) {
                    return await http.get(this.url, params);
                }
            },
            export: {
                url: `${config.API_URL}/api/app/co-op-accrual-previous/export`,
                name: "导出发票数据",
                post: async function (params) {
                    return await http.post(this.url, params, {
                        responseType: 'blob'
                    });
                }
            }
        }
    },
    coOpC2F0: {
        getPageList: {
            url: `${config.API_URL}/api/app/remittance-payment-detail/c2Fo-list`,
            name: "获取C2Fo数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/remittance-payment-detail/get-c2Fo-list-export`,
            name: "导出数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    coOpChargebacks: {
        getPageList: {
            url: `${config.API_URL}/api/app/remittance-payment-detail/chargebacks-list`,
            name: "获取C2FoChargebacks数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/remittance-payment-detail/get-chargebacks-list-export`,
            name: "导出数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    coOpQuantityVarianceShortage: {
        getPageList: {
            url: `${config.API_URL}/api/app/remittance-payment-detail/quantity-variance-shortage-list`,
            name: "获取数量短缺差异数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        export: {
            url: `${config.API_URL}/api/app/remittance-payment-detail/get-quantity-variance-shortage-list-export`,
            name: "导出数据",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        }
    },
    settlementCenter: {
        summary: {
            url: `${config.API_URL}/api/app/financial-settlement-statistics/summary`,
            name: "结算中心汇总",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        }
    },
    remittancePayment: {
        getPageList: {
            url: `${config.API_URL}/api/app/remittance-payment/page-list`,
            name: "获取账单分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        remittancePaymentExport: {
            url: `${config.API_URL}/api/app/remittance-payment/export`,
            name: "账单数据列表导出",
            post: async function (params) {
                return await http.post(this.url, params, {
                    responseType: 'blob'
                });
            }
        },
        getDetails: {
            url: `${config.API_URL}/api/app/remittance-payment/detail-page-list`,
            name: "获取详情数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        detailExport: {
            export: {
                url: `${config.API_URL}/api/app/remittance-payment/export-detail`,
                name: "导出支付账单详情数据",
                post: async function (params) {
                    return await http.post(this.url, params, {
                        responseType: 'blob'
                    });
                }
            }
        }
    },
    financialReport: {
        getPageList: {
            url: `${config.API_URL}/api/app/profit-report/page-list`,
            name: "获取PO发票分页数据",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
    }
}